import { cn } from '@/common/utils/cn'

export interface RadioProps {
  checked: boolean
  onChange?: () => void
  disabled?: boolean
  name?: string
  value?: string
  className?: string
  dataTestid?: string
}

const Radio = ({ checked, onChange, disabled = false, name, value, className, dataTestid }: RadioProps) => {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={checked}
      aria-disabled={disabled}
      data-testid={dataTestid || (name ? `${name}_radio` : undefined)}
      onClick={(event) => {
        event.stopPropagation()
        if (disabled) return
        onChange?.()
      }}
      data-name={name}
      data-value={value}
      disabled={disabled}
      className={cn(
        'size-6 rounded-full flex items-center justify-center shrink-0 transition-colors',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-success focus-visible:ring-offset-2 focus-visible:ring-offset-transparent',
        checked ? 'border-2 border-success bg-transparent p-1' : 'bg-gray-disabled',
        disabled && 'opacity-60 cursor-not-allowed',
        !disabled && 'cursor-pointer',
        className,
      )}
    >
      {checked && <span className="shrink-0 size-4 rounded-full bg-success block" />}
    </button>
  )
}

export default Radio
